import {Component, OnInit, ViewChild} from '@angular/core';
import {SnotifyService} from 'ng-snotify';
import {MBulkGiftVoucherCustomer} from './model/m-bulk-gift-voucher-customer-dto';
import {MBulkGiftVoucherCustomerService} from './service/m-gift-voucher-customer.service';
import {AppSettings} from '../../settings/app-settings';

@Component({
  selector: 'app-gift-voucher-bulk-customer',
  templateUrl: './m-gift-voucher-bulk-customer.component.html'
})
export class MGiftVoucherBulkCustomerComponent implements OnInit {


  private mBulkGiftVoucherCustomers: MBulkGiftVoucherCustomer[] = [];
  private filter: string;
  private mBulkGiftVoucherCustomer: MBulkGiftVoucherCustomer;
  private uiMode: string;
  @ViewChild('inputForm') inputForm;

  constructor(private mBulkGiftVoucherCustomerService: MBulkGiftVoucherCustomerService,
              private snotifyService: SnotifyService) {
    this.mBulkGiftVoucherCustomer = new MBulkGiftVoucherCustomer();
  }

  ngOnInit() {
    this.uiMode = 'IDEAL';
    this.loadMBulkGiftVoucherCustomer();
  }

  sumbmitFormData(): void {
    if (this.inputForm.invalid) {
      this.snotifyService.error('Fill All Input Text', AppSettings.MESSAGE_WARNING, {
        timeout: 2000,
        showProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true
      });
    } else {
      this.snotifyService.confirm('Save ?..', AppSettings.MESSAGE_INFO, {
        timeout: 5000,
        showProgressBar: false,
        closeOnClick: false,
        pauseOnHover: false,
        buttons: [
          {
            text: 'Yes', action: (toast) => {
              this.snotifyService.remove(toast.id);
              this.mBulkGiftVoucherCustomerService.save(this.mBulkGiftVoucherCustomer).subscribe((mainMBulkGiftVoucherCustomer) => {
                this.mBulkGiftVoucherCustomers.push(mainMBulkGiftVoucherCustomer);
                this.snotifyService.success('Store Save Success!', AppSettings.MESSAGE_SUCCESS, {
                  timeout: 2000,
                  showProgressBar: false,
                  closeOnClick: false,
                  pauseOnHover: true
                });
                this.clearFormData();
              }, (e) => {
                this.snotifyService.error(e.error.message, AppSettings.MESSAGE_ERROR, {
                  timeout: 2000,
                  showProgressBar: false,
                  closeOnClick: false,
                  pauseOnHover: true
                });
              });
            }
          },
          {
            text: 'No', action: (toast) => {
              this.snotifyService.remove(toast.id);
            }, bold: true
          },
        ]
      });
    }
  }

  deleteFormData(): void {
    this.snotifyService.confirm('Delete ?..', AppSettings.MESSAGE_WARNING, {
      timeout: 5000,
      showProgressBar: false,
      closeOnClick: false,
      pauseOnHover: false,
      buttons: [
        {
          text: 'Yes', action: (toast) => {
            this.snotifyService.remove(toast.id);
            this.mBulkGiftVoucherCustomerService.delete(this.mBulkGiftVoucherCustomer.indexNo).subscribe((data) => {
                this.snotifyService.success('Gift Voucher Bulk Customer Delete Success!', AppSettings.MESSAGE_SUCCESS, {
                  timeout: 2000,
                  showProgressBar: false,
                  closeOnClick: false,
                  pauseOnHover: true
                });
                this.clearFormData();
              },
              (e) => {
                this.snotifyService.error(e.error.message, AppSettings.MESSAGE_ERROR, {
                  timeout: 2000,
                  showProgressBar: false,
                  closeOnClick: false,
                  pauseOnHover: true
                });
              });
          }
        },
        {
          text: 'No', action: (toast) => {
            this.snotifyService.remove(toast.id);
          }, bold: true
        },
      ]
    });
  }

  selectFormData(rowNo, mBulkGiftVoucherCustomer: MBulkGiftVoucherCustomer) {
    this.uiMode = 'SELECTED';
    this.mBulkGiftVoucherCustomer = mBulkGiftVoucherCustomer;
    this.mBulkGiftVoucherCustomers.splice(rowNo, 1);
  }

  newFormData(): void {
    this.uiMode = 'EDIT';
  }

  clearFormData(): void {
    this.inputForm.reset();
    this.uiMode = 'IDEAL';
    this.loadMBulkGiftVoucherCustomer();
  }

  loadMBulkGiftVoucherCustomer(): void {
    this.mBulkGiftVoucherCustomerService.findAll().subscribe((data) => {
        this.mBulkGiftVoucherCustomers = data;
      },
      (e) => {
        this.mBulkGiftVoucherCustomers = [];
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/view/master-files/m-gift-voucher-bulk-customer/m-gift-voucher-bulk-customer.component.ts